import { Box, styled } from '@chilipiper/design-system'

export const StyledContainer = styled(Box)`
  position: relative;
  background: ${({ theme }) => theme.colors['bg/minor']};

  ::after {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0;
    pointer-events: none;
    border-radius: ${({ theme }) => theme.radii[12]};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors['bg/scrollbar-scrollbar-control']} inset;
  }
`
